// src/router/guards/authGuard.js
import store from '@/store';
import { Roles } from '../constants.js';

// returns `true` to proceed, or a route location for redirect
export async function authGuard(to) {
    if (!to.matched.some(r => r.meta.requiresAuth)) {
        return true;               // public route
    }

    // ensure we have user data
    if (!store.state.user.data) {
        await store.dispatch('user/fetch');
    }
    
    const user = store.getters['user/user'];

    if (!user) {
        return { name: 'Login' };  // not authenticated
    }

    const requiredRole = to.meta.role;
    // If admin route, check isAdmin boolean
    if (requiredRole === Roles.ADMIN) {
        if (!user.isAdmin) {
            // Not admin, redirect to their dashboard
            switch (user.role) {
                case Roles.TEACHER: return { name: 'TeacherDashboard' };
                case Roles.STUDENT: return { name: 'StudentDashboard' };
                default:            return { name: 'Login' };
            }
        }
    } else if (requiredRole && user.role !== requiredRole) {
        // role mismatch – send user to their own dashboard
        switch (user.role) {
            case Roles.TEACHER: return { name: 'TeacherDashboard' };
            case Roles.STUDENT: return { name: 'StudentDashboard' };
            case Roles.ADMIN:   return { name: 'AdminDashboard' };
            default:            return { name: 'Login' };
        }
    }

    return true;                 // authorised
}
